import React from 'react';
import { Image } from './Image';
import styles from './ImageWithOverlay.module.scss';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const ImageWithOverlay = ({
  alt,
  className,
  image,
  overlayUrl,
  opts,
  itemProp,
  preloadImage,
}) => {
  return (
    <>
      <Image
        alt={alt}
        title={alt}
        preload={preloadImage}
        itemProp={itemProp}
        className={className}
        image={image}
        opts={opts}
      />
      {overlayUrl && (
        <Image
          alt={alt}
          title={alt}
          preload={preloadImage}
          itemProp={itemProp}
          className={clsx(styles.overlayImage, className)}
          image={overlayUrl}
          opts={{
            ...opts,
            gravity: 'north_west',
          }}
        />
      )}
    </>
  );
};

ImageWithOverlay.propTypes = {
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  overlayUrl: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  opts: PropTypes.object,
  itemProp: PropTypes.string,
};
